import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { useEffect, useState, type JSX } from 'react';
import { useCollapse } from 'react-collapsed';
import { ExpandableBody } from './components/expandable-body';
import { ExpandableHead } from './components/expandable-head';
export interface ExpandableRowProps {
  children: React.ReactElement<unknown>[];
  removeStyling?: boolean;
  expanded?: boolean;
  onToggleRow?: (isExpanded: boolean) => void;
  shouldToggleOnClick?: boolean;
  disabled?: boolean;
}
export function ExpandableRow(t0) {
  const $ = _c(36);
  const {
    children,
    removeStyling: t1,
    expanded: t2,
    disabled: t3,
    onToggleRow,
    shouldToggleOnClick: t4
  } = t0;
  const removeStyling = t1 === undefined ? false : t1;
  const expanded = t2 === undefined ? false : t2;
  const disabled = t3 === undefined ? false : t3;
  const shouldToggleOnClick = t4 === undefined ? true : t4;
  const [isExpanded, setIsExpanded] = useState(expanded);
  let t5;
  if ($[0] !== isExpanded) {
    t5 = {
      isExpanded,
      duration: 200
    };
    $[0] = isExpanded;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const {
    getCollapseProps,
    getToggleProps
  } = useCollapse(t5);
  let t6;
  let t7;
  if ($[2] !== expanded) {
    t6 = () => {
      setIsExpanded(expanded);
    };
    t7 = [expanded];
    $[2] = expanded;
    $[3] = t6;
    $[4] = t7;
  } else {
    t6 = $[3];
    t7 = $[4];
  }
  useEffect(t6, t7);
  let t8;
  if ($[5] !== isExpanded || $[6] !== onToggleRow || $[7] !== shouldToggleOnClick) {
    t8 = () => {
      if (!shouldToggleOnClick) {
        onToggleRow?.(isExpanded);
        return;
      }
      setIsExpanded(_temp);
      onToggleRow?.(!isExpanded);
    };
    $[5] = isExpanded;
    $[6] = onToggleRow;
    $[7] = shouldToggleOnClick;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== disabled || $[10] !== getToggleProps || $[11] !== t8) {
    t9 = getToggleProps({
      onClick: t8,
      disabled
    });
    $[9] = disabled;
    $[10] = getToggleProps;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== isExpanded || $[14] !== t9) {
    t10 = {
      getToggleProps: t9,
      isExpanded
    };
    $[13] = isExpanded;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const headProps = t10;
  let t11;
  if ($[16] !== getCollapseProps) {
    t11 = {
      getCollapseProps
    };
    $[16] = getCollapseProps;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const bodyProps = t11;
  if (removeStyling) {
    let t12;
    if ($[18] !== children[0] || $[19] !== headProps) {
      t12 = React.cloneElement(children[0], headProps);
      $[18] = children[0];
      $[19] = headProps;
      $[20] = t12;
    } else {
      t12 = $[20];
    }
    let t13;
    if ($[21] !== bodyProps || $[22] !== children[1]) {
      t13 = React.cloneElement(children[1], bodyProps);
      $[21] = bodyProps;
      $[22] = children[1];
      $[23] = t13;
    } else {
      t13 = $[23];
    }
    let t14;
    if ($[24] !== t12 || $[25] !== t13) {
      t14 = <>{t12}{t13}</>;
      $[24] = t12;
      $[25] = t13;
      $[26] = t14;
    } else {
      t14 = $[26];
    }
    return t14;
  }
  let t12;
  if ($[27] !== children[0] || $[28] !== headProps) {
    t12 = React.cloneElement(children[0], headProps);
    $[27] = children[0];
    $[28] = headProps;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== bodyProps || $[31] !== children[1]) {
    t13 = React.cloneElement(children[1], bodyProps);
    $[30] = bodyProps;
    $[31] = children[1];
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t12 || $[34] !== t13) {
    t14 = <div className="bg-background shadow-cardShadow overflow-hidden rounded-xs border">{t12}{t13}</div>;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
}
function _temp(oldExpanded) {
  return !oldExpanded;
}
export { ExpandableBody, ExpandableHead };